import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { constants, KlarnaLogoFull } from '@klarna/bubble-ui';

const COLOR_MAP = {
  pink: constants.Colors.palette.KlarnaBrandPrimary,
  black: constants.Colors.palette.Black,
  white: constants.Colors.palette.White,
};

const Container = styled.div`
  display: flex;
  align-items: baseline;
  line-height: 26px;
`;

const KlarnaLogoContainer = styled.div`
  background-color: ${({ type }) => COLOR_MAP[type]};
  border: 1px solid ${({ type }) => (type === 'white' ? '#C7C9CC' : 'unset')};
  border-radius: 4px;
  height: 22px;
  margin-right: 5px;
  padding: 2px 0px 0px 4px;
`;

/** color and size of the letters inside the logo */
const svgProps = {
  width: 44,
  height: 13,
};

const pathStyle = {
  transform: 'scale(0.5)',
};

const KlarnaLogo = ({ type = 'pink' }) => (
  <Container>
    <KlarnaLogoContainer type={type}>
      <KlarnaLogoFull inverse={type === 'black'} UNSAFE_pathStyle={pathStyle} {...svgProps} />
    </KlarnaLogoContainer>
  </Container>
);

KlarnaLogo.propTypes = {
  type: PropTypes.oneOf(['pink', 'white', 'black']),
};

KlarnaLogo.defaultProps = {
  type: 'pink',
};

export { KlarnaLogo };
